import { toast } from "react-toastify";

// Static placeholder -- there is no intranet-source sync backend yet. The
// "Connected sources" list below is sample data purely to match the design.
const SAMPLE_SOURCES = [
  { id: "sp-1", label: "SP", name: "SharePoint — Clinical Policies", detail: "Synced 12 minutes ago · 842 documents", status: "connected" },
  { id: "sp-2", label: "SP", name: "SharePoint — HR Handbook", detail: "Synced 3 hours ago · 96 documents", status: "connected" },
  { id: "web-1", label: "WEB", name: "Intranet knowledge base", detail: "Last crawl failed · authentication error", status: "error" },
];

const statusStyles = {
  connected: "bg-green-100 text-green-700",
  error: "bg-red-100 text-red-700",
};

const IntranetTab = ({ facility }) => {
  const baseUrl = facility?.intranet_allowed_domains?.[0] || "";

  return (
    <div>
      <div className="mb-5">
        <h3 className="text-base font-bold text-gray-900">Intranet configuration</h3>
        <p className="text-sm text-gray-500">Connect internal links and SharePoint sources</p>
        <p className="mt-1 text-xs italic text-gray-400">Sample data &mdash; source syncing is not yet connected to a live source.</p>
      </div>

      <div className="mb-6">
        <label className="mb-1 block text-sm font-medium text-gray-700">Intranet base URL</label>
        <div className="flex gap-2">
          <input
            type="text"
            readOnly
            value={baseUrl}
            placeholder="intranet.example.org"
            className="flex-1 rounded-lg border border-gray-200 bg-gray-50 px-3.5 py-2.5 text-sm text-gray-600"
          />
          <button
            type="button"
            onClick={() => toast.info("Intranet sync isn't available yet.")}
            className="rounded-lg bg-[#2B3674] px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-800"
          >
            Test connection
          </button>
        </div>
      </div>

      <h4 className="mb-3 text-sm font-bold text-gray-900">Connected sources</h4>
      <div className="divide-y divide-gray-100 rounded-xl border border-gray-100">
        {SAMPLE_SOURCES.map((source) => (
          <div key={source.id} className="flex items-center justify-between px-5 py-3">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gray-100 text-xs font-semibold text-gray-500">
                {source.label}
              </span>
              <div>
                <p className="text-sm font-semibold text-gray-900">{source.name}</p>
                <p className="text-xs text-gray-500">{source.detail}</p>
              </div>
            </div>
            <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${statusStyles[source.status]}`}>
              {source.status === "connected" ? "Connected" : "Error"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntranetTab;
